var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass:
        "icon-details-animations margin-bottom-2xl laptop:margin-top-2xl laptop:margin-bottom-0",
      staticStyle: {
        "--color-input-min-width": "var(--icon-details-input-color-min-width)",
      },
      attrs: { id: "icon-animations", action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c("div", { staticClass: "styling-animate" }, [
        _c(
          "div",
          {
            staticClass: "size-xs padding-right-md padding-bottom-md",
            staticStyle: { "flex-shrink": "0" },
          },
          [
            _c(
              "span",
              {
                staticClass: "text-uppercase padding-right-sm",
                staticStyle: {
                  "letter-spacing": "var(--letter-spacing-3xl)",
                  "font-weight": "var(--font-weight-black)",
                },
              },
              [_vm._v("Animate")]
            ),
            _vm._v(" "),
            _c(
              "site-link",
              {
                staticStyle: { "--link-color": "var(--fa-gravy)" },
                attrs: {
                  to: _vm.getDocsPath("/web/style/animate", {
                    version: _vm.majorVersion,
                  }),
                  "aria-label":
                    "With our web toolkit, you can easily add animations to an icon with a CSS class. Click to learn more",
                  "data-balloon-pos": "right",
                  "data-balloon-length": "xlarge",
                },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.$v7.solid.faInfoCircle },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "custom-radio-button-set display-flex align-stretch flex-wrap",
            staticStyle: {
              "--list-style-type": "none",
              "--padding-left": "0",
              "--list-margin-top": "0",
              "flex-grow": "1",
              gap: "var(--spacing-xs)",
            },
          },
          _vm._l(_vm.iconAnimations, function (animationsSelect) {
            return _c(
              "li",
              {
                key: animationsSelect.name,
                staticClass: "icon-details-animation-button position-relative",
                style: _vm.radioCustomStyles,
              },
              [
                animationsSelect.value === null
                  ? [
                      _c("input", {
                        staticStyle: {
                          appearance: "none",
                          position: "absolute",
                          "box-shadow": "none",
                        },
                        attrs: {
                          id: "animations-none",
                          type: "radio",
                          name: "icon-animations",
                          value: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change(
                              "animation",
                              animationsSelect.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "margin-0 padding-y-xs padding-x-xl",
                          staticStyle: {
                            "border-radius": "var(--border-radius-md)",
                            "flex-grow": "1",
                            "background-color": "var(--fa-lt-gravy)",
                          },
                          attrs: { for: "animations-none" },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "padding-right-4xs",
                            attrs: { icon: _vm.$v7.solid.faBan },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(animationsSelect.name))]),
                        ],
                        1
                      ),
                    ]
                  : [
                      _c("input", {
                        staticStyle: {
                          appearance: "none",
                          position: "absolute",
                          "box-shadow": "none",
                        },
                        attrs: {
                          id: `animations-${animationsSelect.value}`,
                          type: "radio",
                          name: "icon-animations",
                        },
                        domProps: {
                          value: animationsSelect.value,
                          checked:
                            animationsSelect.value === _vm.styling.animation,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.change(
                              "animation",
                              animationsSelect.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "margin-0 padding-y-xs padding-x-xl",
                          staticStyle: {
                            "border-radius": "var(--border-radius-md)",
                            "flex-grow": "1",
                          },
                          attrs: {
                            for: `animations-${animationsSelect.value}`,
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "padding-right-4xs",
                            attrs: {
                              icon: _vm.$v7.solid[animationsSelect.icon],
                              size: "lg",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(animationsSelect.name))]),
                        ],
                        1
                      ),
                    ],
              ],
              2
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }